import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SavedSearchCommonDataService {
  public unsavedChanges: boolean = false;
  public currentSearchId: number | undefined = undefined;
  public searchRevision = 0;
  public standaloneEorRevision: number | undefined;
  public hasStandaloneEorForCurrentSearch = false;

  public get hasUnchangedStandaloneEor(): boolean {
    return this.hasStandaloneEorForCurrentSearch && this.standaloneEorRevision === this.searchRevision;
  }

  public markStandaloneEorGenerated(): void {
    this.hasStandaloneEorForCurrentSearch = true;
    this.standaloneEorRevision = this.searchRevision;
  }

  public reset() {
    this.unsavedChanges = false;
    this.currentSearchId = undefined;
    this.searchRevision = 0;
    this.standaloneEorRevision = undefined;
    this.hasStandaloneEorForCurrentSearch = false;
  }

  public clearSavedSearch() {
    this.unsavedChanges = true;
    this.currentSearchId = undefined;
    this.searchRevision++;
  }
}
